import fvAnimation from "./fvAnimation"
export default class fvHeight extends fvAnimation {
    constructor(shape) {
        super(shape, "fvHeight");
        //获取高
        this.org = this.orgHeight;
        this.orgHeight = shape.height;
        this.orgY = shape.y;
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.MaxPerc = AsyncFunction("return " + this.MaxPerc);
        this.MinPerc = AsyncFunction("return " + this.MinPerc);
    }
    async run(domObject, value) {
        if (value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        var MaxPercValue = await this.executionScript(this.MaxPerc);
        var MinPercValue = await this.executionScript(this.MinPerc);
        if (this.MaxValue == this.MinValue) return;
        if (size == -9999) return;
        var curPerc = (MaxPercValue - MinPercValue) * (size - this.MinValue) / (this.MaxValue - this.MinValue);
        let addHeight = this.orgHeight * curPerc / 100;
        let difference = this.shape.height - addHeight;
        switch (parseInt(this.org)) {
            case 0:
                domObject.style.height = addHeight + "px";
                break;
            case 50:
                domObject.setAttribute('y', this.shape.cy - this.shape.parent.y + (this.shape.height / 2) - (addHeight / 2));
                domObject.style.height = addHeight + "px";
                break;
            case 100:
                let newWidth = this.shape.height - addHeight;
                domObject.setAttribute('y', this.shape.cy - this.shape.parent.y + difference);
                domObject.style.height = addHeight + "px";
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvHeight.js